import { h } from './dom.js'
import { state, replaceStamps } from '../lib/state.js'
import { shiftStamps } from '../lib/timeline.js'
import { openDialog } from './dialog.js'
import { toast } from './toast.js'

// Drift fixer: shift every timestamp from a given move (or all of them)
// by ±N seconds, so one late camera bump doesn't mean re-tagging the game.
export async function openShiftDialog(fromIndex = 0) {
  const move = state.pgn.moves[fromIndex]
  const deltaInput = h('input.text-input', {
    type: 'number',
    step: '0.1',
    value: '0.5',
    'aria-label': 'Shift amount in seconds',
  })
  const scopeFrom = h('input', { type: 'radio', name: 'shift-scope', value: 'from', checked: true })
  const scopeAll = h('input', { type: 'radio', name: 'shift-scope', value: 'all' })

  const countFrom = state.stamps.filter((s, i) => s != null && i >= fromIndex).length
  const countAll = state.stamps.filter((s) => s != null).length

  const body = h(
    'div.shift-form',
    {},
    h(
      'label.field',
      {},
      h('span.field-label', {}, 'Shift by (seconds, negative = earlier)'),
      deltaInput,
    ),
    h(
      'div.field',
      {},
      h('span.field-label', {}, 'Apply to'),
      h(
        'label.radio-row',
        {},
        scopeFrom,
        move ? `From ${move.label} onward (${countFrom} tagged)` : `From move ${fromIndex + 1} onward (${countFrom} tagged)`,
      ),
      h('label.radio-row', {}, scopeAll, `All moves (${countAll} tagged)`),
    ),
  )

  const result = await openDialog({
    title: 'Shift timestamps',
    body,
    actions: [
      { label: 'Cancel', value: null },
      { label: 'Shift', value: 'apply', primary: true },
    ],
  })
  if (result !== 'apply') return

  const delta = parseFloat(deltaInput.value)
  if (!Number.isFinite(delta) || delta === 0) {
    toast('Nothing shifted — enter a non-zero number of seconds', { kind: 'warn' })
    return
  }
  const start = scopeAll.checked ? 0 : fromIndex
  const affected = state.stamps.filter((s, i) => s != null && i >= start).length
  if (!affected) {
    toast('Nothing shifted — no tagged moves in that range', { kind: 'warn' })
    return
  }
  replaceStamps(shiftStamps(state.stamps, { fromIndex: start, delta }))
  const sign = delta > 0 ? '+' : ''
  toast(`Shifted ${affected} ${affected === 1 ? 'timestamp' : 'timestamps'} by ${sign}${delta}s`)
}
